(function ($) {
    $.fn.addPermission = function () {
        this.on('click', function (event) {
            event.preventDefault();
            var element = $(event.target);
            var count = $('.permissions').find('tbody').find('tr').length;

            element.closest('.permissions').find('tbody').append('<tr>\
                <td>\
                    <input type="checkbox" name="permissions[' + count + '][delete]"/>\
                    <input type="hidden"\
                        name="permissions[' + count + '][service]"\
                        value="' + element.data('service') + '"\
                >\
                </td>\
                <td>\
                    <input type="text" class="form-control"\
                        name="permissions[' + count + '][key]"\
                    >\
                </td>\
                <td>\
                    <input type="text" class="form-control"\
                        name="permissions[' + count + '][value]"\
                    >\
                </td>\
                </tr>');
        });

        return this;
    };
}(jQuery));
